import { z } from 'zod/v4-mini';

import { config } from '$/config';

const seamlessTextureEndpoint = `${import.meta.env.VITE_VEEUZE_INTEGRATE_BASE_URL}/v2.1/cust/caparol/get_cad_material.php?cnf=${config.veeuzeCnf}`;

export const MaterialTypeSchema = z.union([
  z.literal('color_tint'),
  z.literal('floor_texture'),
  z.literal('wall_texture'),
  z.literal('facade_texture'),
]);

export type MaterialType = z.infer<typeof MaterialTypeSchema>;
export type FilterType = 'all' | MaterialType;

export const materialTypes = [
  'color_tint',
  'floor_texture',
  'wall_texture',
  'facade_texture',
] as const;

export const MaterialSchema = z.pipe(
  z.object({
    id: z.string(),
    type: z.array(MaterialTypeSchema).check(z.minLength(1)),
    producer: z.string(),
    collection: z.string(),
    name: z.string(),
    family: z.string(),
    lrv: z.number(),
    rgb: z.array(z.number()),
    lch: z.array(z.number()),
    hex: z.string(),
    colorRanges: z.array(z.string()),
    page: z.number(),
    pageCount: z.number(),
    pagePosition: z.number(),
    textureWidth: z.nullable(z.number()),
    textureHeight: z.nullable(z.number()),
    textureRepeat: z.nullable(z.number()),
    texturePath: z.nullable(z.string()),
    isProMaterial: z.boolean(),
    veeuze: z.object({
      id: z.string(),
    }),
  }),
  z.transform((material) => ({
    ...material,
    url: ({ size = '500' } = {}) =>
      material.texturePath
        ? `https://daw_integrate_own_db.aocluster.com/v2.1/get_img_material.php?cnf=${config.veeuzeCnf}&mid=${material.veeuze.id}&w=${size}&h=${size}`
        : undefined,
    seamlessTextureUrl: (dimensions?: { xSize: number; ySize: number }) => {
      if (!material.texturePath) return undefined;
      const seamlessTextureUrl = `${seamlessTextureEndpoint}&mid=${material.veeuze.id}`;
      if (dimensions != null) {
        return `${import.meta.env.VITE_IMAGEPROXY_URL}/_/rs:fit:${dimensions.xSize}:${dimensions.ySize}:0/plain/${seamlessTextureUrl.replace('?', '%3F')}`;
      }
      return seamlessTextureUrl;
    },
  })),
);

export type Material = z.infer<typeof MaterialSchema>;
